import React from 'react';
import { DropdownItem } from 'reactstrap';

import { CurrentLang } from "common";

const AUTO_COMPLETE_OFF = 'off';

class MagstimInputGroup extends React.Component {

    constructor() {
		super();

		this.state = {
            checked: undefined,
            disabled:undefined,
            checkedFromProps: undefined
		};
    }

    static getDerivedStateFromProps(props, state) {
        
        // Only update when the props are changed and set disabled based on the checked state
        if(state.checkedFromProps !== props.checked ){
            state.checked = props.checked;
            state.disabled = !props.checked; 

            state.checkedFromProps = state.checked;
        }
        
        return state;
    }

    resetState(){
        this.state({checked: undefined, disabled: undefined});
    }
    
    onFocus = event => {
        if (event.target.autocomplete) event.target.autocomplete = AUTO_COMPLETE_OFF;
    }

    dropdownItem = (option, defaultOption) =>{

        if(option.Guid !== undefined && option.Name !== undefined){
           return <DropdownItem id={option.Guid} key={option.Guid} value={option.Name}  active={option.Name === defaultOption || option.Guid === defaultOption}>{option.Name}</DropdownItem>
        }else{
    
            // Try to translate 
            var optionName = CurrentLang()[`status_${option.toLowerCase()}`];
    
            if(optionName === undefined){
                optionName = CurrentLang()[`physician_type_${option.toLowerCase()}`];
            }

            if(optionName === undefined){
                optionName = CurrentLang()[`enum_usertype_${option.toLowerCase()}`];
            }

            if(optionName === undefined){
                optionName = CurrentLang()[`treatment_stage_${option.toLowerCase()}`];
            }
    
            if(optionName === undefined){
                optionName = option;
            }
    
            return <DropdownItem id={option} key={option} value={option} active={option === defaultOption}>{optionName}</DropdownItem>
        }
    }
}


export default MagstimInputGroup